import { render, staticRenderFns } from "./CampaignDeleteModal.vue?vue&type=template&id=3f24af16"
import script from "./CampaignDeleteModal.vue?vue&type=script&lang=js"
export * from "./CampaignDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports